import { Inject, Injectable } from "@angular/core";
import { DOCUMENT } from "@angular/common";

@Injectable({
    providedIn: 'root'
})
export class TfCopyToClipboardService {

    constructor(@Inject(DOCUMENT) private document: Document ) {
    }

    copyToClipboard(content: string): boolean {
        const textArea = this.document.createElement("textarea");
        textArea.style.position = "fixed";
        textArea.value = content;
        this.document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        let saved = false;
        try {
            saved = this.document.execCommand('copy');
        } catch (err) {
            console.error('Unable to copy to clipboard');
        }
        this.document.body.removeChild(textArea);
        return saved;
    }

}
